import { TagTypeEnum } from "../../enum/tagCsrEnum.enum";

export class TagCsrModel {

  ngo_id: string = null;
 
  ngo_name: string = null;
 
  ngo_campaign_id: string = null;
 
  campaign_title: string = null;
 
  name: string = null;
 
  type: TagTypeEnum;

  project_id: string = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}